import { ReactNode } from "react";

interface ChipProps {
  icon?: ReactNode;
  label: string;
  onClick?: () => void;
  onDelete?: () => void;
}

export function Chip({ icon, label, onClick, onDelete }: ChipProps) {
  return (
    <button onClick={onClick} className="inline-block rounded-full bg-gray-200 border-gray-200 border-2 px-2 py-1">
      {icon && <span className="mr-0.5">{icon}</span>}
      {label}
      {onDelete && (
        <button onClick={onDelete} className="ml-0.5">
          x
        </button>
      )}
    </button>
  );
}
